module.exports = __webpack_public_path__ + "static/media/janis-oppliger-178385-unsplash.ab86a4c9.jpg";